import { computed } from "vue";
import { useStore } from "vuex";

const sameWholesalerId = (a, b) =>
  a != null && b != null && String(a) === String(b);

const toWholesalerList = (list) => {
  if (!list) {
    return [];
  }
  const arr = Array.isArray(list) ? list : Object.values(list);
  return arr
    .filter((item) => item && item.id != null && item.id !== "")
    .map((item) => ({
      ...item,
      id: item.id,
      name: item.name ?? "",
    }));
};

/**
 * Options for profile wholesaler selects (verified rows use full list).
 */
export function useWholesalerSelect() {
  const store = useStore();

  const allWholesalers = computed(() =>
    toWholesalerList(store.getters.getAllWholesalers),
  );
  const wholesalers = computed(() =>
    toWholesalerList(store.getters.getWholesalers),
  );

  const isVerifiedDealerRow = (row) => Boolean(row?.verifiedCustomerNumber);

  const findWholesalerName = (wholesalerId, row) => {
    if (row?.wholesaler_name) {
      return row.wholesaler_name;
    }
    if (wholesalerId == null || wholesalerId === "") {
      return "";
    }
    const match =
      allWholesalers.value.find((w) => sameWholesalerId(w.id, wholesalerId)) ||
      wholesalers.value.find((w) => sameWholesalerId(w.id, wholesalerId));
    return match?.name || row?.expected_name || "";
  };

  const optionsForDealerRow = (row) => {
    const wholesalerId = row?.wholesaler_id;

    const base = isVerifiedDealerRow(row)
      ? allWholesalers.value
      : wholesalers.value.length
        ? wholesalers.value
        : allWholesalers.value;

    if (
      wholesalerId == null ||
      wholesalerId === "" ||
      base.some((w) => sameWholesalerId(w.id, wholesalerId))
    ) {
      return base;
    }

    const name = findWholesalerName(wholesalerId, row);

    return [
      ...base,
      {
        id: wholesalerId,
        name: name || String(wholesalerId),
      },
    ];
  };

  const labelForDealerRow = (row) => findWholesalerName(row?.wholesaler_id, row);

  const isWholesalerSelectLocked = (row, canEdit) =>
    !canEdit || isVerifiedDealerRow(row);

  return {
    allWholesalers,
    wholesalers,
    optionsForDealerRow,
    labelForDealerRow,
    isVerifiedDealerRow,
    isWholesalerSelectLocked,
  };
}

export { toWholesalerList, sameWholesalerId };
